var GRID_STYLE = {
    FIT_TO_SCREEN: 0,
    SET_ITEMS_PER_ROW: 1,
};
export default GRID_STYLE;
//# sourceMappingURL=gridStyle.js.map